
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartManagementProposal as ObiChartManagementProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-management-proposal.js';
 
 
 

 
 export const ObiChartManagementProposal = createComponent({
   react: React,
   tagName: 'obi-chart-management-proposal',
   elementClass: ObiChartManagementProposalElement,
   events: {
     
   }
  });
 
 